import { render, staticRenderFns } from "./VehicleNote.vue?vue&type=template&id=22533e44&"
import script from "./VehicleNote.vue?vue&type=script&lang=js&"
export * from "./VehicleNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports